import React, { Component } from 'react'
import { connect } from 'react-redux'

function mapStateToProps(state, hocProps) {
    const { id } = hocProps

    return {
        entity: state.getIn(['ui', 'modules', 'report', 'workspace', id, 'entity'], {}),
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps, null)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
